// Line icons from the COM-471 side menu design (24px grid, stroked).
const GRAY = '#5E6680';

export const NAV_ICONS = {
  '/home': { d: 'M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z', color: '#4CBF73' },
  '/patients': { d: 'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM4 21a8 8 0 0 1 16 0', color: '#E8A71C' },
  '/conversations': { d: 'M4 5h16v16H4zM4 9h16M8 3v4M16 3v4', color: '#E0475B' },
  '/templates': {
    d: 'M10 21H5V3h9l4 4v3M14 3v4h4M8 9h4M8 13h2M20.81 16.16 L22.26 16.32 L22.26 17.68 L20.81 17.84 L20.28 19.10 L21.20 20.23 L20.23 21.20 L19.10 20.28 L17.84 20.81 L17.68 22.26 L16.32 22.26 L16.16 20.81 L14.90 20.28 L13.77 21.20 L12.80 20.23 L13.72 19.10 L13.19 17.84 L11.74 17.68 L11.74 16.32 L13.19 16.16 L13.72 14.90 L12.80 13.77 L13.77 12.80 L14.90 13.72 L16.16 13.19 L16.32 11.74 L17.68 11.74 L17.84 13.19 L19.10 13.72 L20.23 12.80 L21.20 13.77 L20.28 14.90ZM17 18.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z',
    color: '#2FB37A',
  },
  '/settings': { d: 'M3 5h18v14H3zM9 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4zM5.5 16.5a3.5 3.5 0 0 1 7 0M14 10h4M14 14h3', color: GRAY },
  '/admin/team': { d: 'M16 20v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM22 20v-1a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8', color: '#E5603A' },
  '/admin/insights': { d: 'M4 20V10M10 20V4M16 20v-7M2 20h20', color: '#7A5AF8' },
  '/admin/guidelines': { d: 'M6 3h9l4 4v14H6zM9 13l2 2 4-4', color: '#2FB37A' },
  '/account/billing': { d: 'M3 6h18v12H3zM3 10h18M7 15h4', color: '#1B7FA8' },
  gettingStarted: { d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM10 8.5l5.5 3.5-5.5 3.5z', color: GRAY, width: 1.8 },
  integrations: { d: 'M9 2v6M15 2v6M7 8h10v3a5 5 0 0 1-10 0zM12 16v6', color: GRAY, width: 1.8 },
  whatsNew: { d: 'M12 3l1.8 4.7 4.7 1.8-4.7 1.8L12 16l-1.8-4.7-4.7-1.8 4.7-1.8zM19 15l.8 2.2 2.2.8-2.2.8L19 21l-.8-2.2-2.2-.8 2.2-.8z', color: GRAY, width: 1.8 },
  feedback: { d: 'M21 15a2 2 0 0 1-2 2H8l-5 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2zM8 9h8M8 13h5', color: GRAY, width: 1.8 },
  support: { d: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM9.5 9a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .9-1 1.7M12 17h.01', color: '#1D6FB8', width: 1.8 },
  logout: { d: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9', color: GRAY, width: 1.8 },
};

export const NavIcon = ({ name }) => {
  const icon = NAV_ICONS[name];
  if (!icon) return null;
  return (
    <svg
      className="cpt-nav-icon"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke={icon.color}
      strokeWidth={icon.width || 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={icon.d} />
    </svg>
  );
};
